<template>
  <div class="margin-top">
    <div class="text-right">
      <el-button type="primary" size="small" @click="_exportReportEarnedWayExcel">
        <i class="el-icon-download"></i>
        <span>{{ $t('dataReport.export') }}</span>
      </el-button>
    </div>
    <div class="margin-top">
      <!-- 图表区（UI-REPORT-006）：原实现是「单行表格」，改为环形图直观展示收款方式构成 -->
      <ds-chart-panel
        :title="$t('dataReport.earnedWayChartTitle')"
        :subtitle="$t('dataReport.earnedWayChartSubtitle')"
        :loading="loading"
        :empty="isEmpty"
        :summary="chartSummary">
        <ds-report-chart :option="chartOption" height="340px"></ds-report-chart>
        <template slot="empty">
          <ds-empty-state type="no-data" :description="$t('dataReport.earnedWayNoData')"></ds-empty-state>
        </template>
      </ds-chart-panel>

      <!-- 明细区：原表格保留，数值口径与改造前完全一致 -->
      <div class="earned-way-detail">
        <ds-data-table :data="[dataReportEarnedWayStatisticsInfo.fees]" border stripe>
          <el-table-column v-for="(item, index) in dataReportEarnedWayStatisticsInfo.fees" :key="index" :label="item.name"
            align="right">
            <template>
              <span class="ds-amount">{{ item.receivedAmount || 0 }}</span>
            </template>
          </el-table-column>
        </ds-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { queryReceivedWayStatistics, exportData } from '@/api/report/dataReportApi'
import DsChartPanel from '@/components/ds/ds-chart-panel.vue'
import DsReportChart from '@/components/ds/ds-report-chart.vue'
import DsEmptyState from '@/components/ds/ds-empty-state.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import { formatMoney } from '@/utils/format'

export default {
  name: 'DataReportEarnedWayStatistics',
  components: {
    DsChartPanel,
    DsReportChart,
    DsDataTable,
    DsEmptyState
  },

  data() {
    return {
      dataReportEarnedWayStatisticsInfo: {
        fees: []
      },
      startDate: '',
      endDate: '',
      communityId: '',
      loading: false
    }
  },
  created() {
  },
  computed: {
    /**
     * 图表数据源：由后端返回的收款方式数组转换而来，不新增任何接口。
     */
    chartSource() {
      const _fees = this.dataReportEarnedWayStatisticsInfo.fees || []
      return _fees.map(item => ({
        name: item.name,
        value: parseFloat(item.receivedAmount) || 0
      }))
    },
    isEmpty() {
      return this.chartSource.filter(item => item.value > 0).length === 0
    },
    chartOption() {
      const _source = this.chartSource
      return {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const _percent = params.percent === undefined ? '' : ` (${params.percent}%)`
            return `${params.name}: ${formatMoney(params.value)}${_percent}`
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle'
        },
        series: [{
          id: 'earned-way-pie',
          name: this.$t('dataReport.earnedWayChartTitle'),
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['62%', '50%'],
          label: {
            formatter: '{b}\n{d}%'
          },
          labelLine: {
            length: 12,
            length2: 12
          },
          data: _source
        }]
      }
    },
    chartSummary() {
      if (this.isEmpty) return ''
      const _total = this.chartSource.reduce((sum, item) => sum + item.value, 0)
      const _top = this.chartSource.slice().sort((a, b) => b.value - a.value)[0]
      return `${this.$t('dataReport.earnedWaySummary')}: ${formatMoney(_total)}, ${_top.name} ${_top.value > 0 ? Math.round(_top.value / _total * 100) : 0}%`
    }
  },
  methods: {
    open(_param) {
      this.startDate = _param.startDate
      this.endDate = _param.endDate
      this.communityId = _param.communityId
      this._loadDataReportEarnedWayStatisticsData()
    },
    async _loadDataReportEarnedWayStatisticsData() {
      this.loading = true
      try {
        const params = {
          communityId: this.communityId,
          startDate: this.startDate,
          endDate: this.endDate
        }
        const { data } = await queryReceivedWayStatistics(params)
        this.dataReportEarnedWayStatisticsInfo.fees = data
      } catch (error) {
        console.error('Failed to load data:', error)
        this.dataReportEarnedWayStatisticsInfo.fees = []
        this.$message.error(this.$t('common.operationFailed'))
      } finally {
        this.loading = false
      }
    },
    async _exportReportEarnedWayExcel() {
      try {
        const params = {
          communityId: this.communityId,
          startDate: this.startDate,
          endDate: this.endDate,
          pagePath: 'dataReportEarnedWayStatistics'
        }
        const res = await exportData(params)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
        }
      } catch (error) {
        console.error('Export failed:', error)
      }
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}

.earned-way-detail {
  margin-top: 16px;
}
</style>
